// extracted by mini-css-extract-plugin
export var tagItem = "d";
export var countItem = "e";